<template>
  <SearchBar
    v-if="!isHeaderMode || !isScreenMdMin"
    :searchListHistory="searchListHistory"
    :searchListApi="searchListApi"
    :locationListHistory="locationListHistory"
    :locationListApi="locationListApi"
    @onSearch="$emit('onSearch', $event)"
    @onClearSearchHistory="$emit('onClearSearchHistory', $event)"
    @onLocationinput="$emit('onLocationinput', $event)"
    @onRemoveSearchItem="$emit('onRemoveSearchItem', $event)"
    @onClearLocationHistory="$emit('onClearLocationHistory', $event)"
    @onRemoveLocationItem="$emit('onRemoveLocationItem', $event)"
    @onSearchinput="$emit('onSearchinput', $event)"
  />
  <template v-else>
    <div class="hero-banner-search-mobile">
      <button
        class="btn-search"
        ref="buttonRef"
        @click="displayModal = true">
          <i class="icon-search" aria-hidden="true"></i>
          <span class="sr-only">Ouvrir la recherche</span>
      </button>
    </div>
  </template>
  <SearchBarMobile
    v-if="displayModal"
    :searchListHistory="searchListHistory"
    :searchListApi="searchListApi"
    @onLocationinput="$emit('onLocationinput', $event)"
    :locationListHistory="locationListHistory"
    :locationListApi="locationListApi"
    @onSearch="$emit('onSearch', $event)"
    @onClearSearchHistory="$emit('onClearSearchHistory', $event)"
    @onRemoveSearchItem="$emit('onRemoveSearchItem', $event)"
    @onClearLocationHistory="$emit('onClearLocationHistory', $event)"
    @onRemoveLocationItem="$emit('onRemoveLocationItem', $event)"
    @onSearchinput="$emit('onSearchinput', $event)"
    @onCloseModal="onCloseModal"
  />
</template>

<script>
import { inject, ref } from 'vue';
import { KEYBOARD_CONST } from '@/const';
import SearchBar from '@/components/homePage/SearchBar.component.vue';
import SearchBarMobile from '@/components/homePage/SearchBarMobile.component.vue';

export default {
  components: {
    SearchBar,
    SearchBarMobile,
  },
  emits: [
    'onSearch',
    'onClearSearchHistory',
    'onRemoveSearchItem',
    'onClearLocationHistory',
    'onRemoveLocationItem',
    'onSearchinput',
    'onLocationinput',
  ],
  props: {
    searchListHistory: {
      type: Array,
      default: () => [],
    },
    searchListApi: {
      type: Array,
      default: () => [],
    },
    locationListHistory: {
      type: Array,
      default: () => [],
    },
    locationListApi: {
      type: Array,
      default: () => [],
    },
  },

  setup() {
    const displayModal = ref(false);
    const inputRef = ref(null);
    const buttonRef = ref(null);
    const isHeaderMode = inject('isHeaderMode');
    const isScreenMdMin = inject('isScreenMdMin');
    const what = inject('what');
    const where = inject('where');
    const searchPlaceholders = inject('searchPlaceholders');
    const searchPlaceholderTitle = searchPlaceholders.text_mobile;

    let initialSearch = '';

    if (what) {
      initialSearch = `${what}${where ? `, ${where}` : ''}`;
    }

    function handleKeydown(event) {
      const { keyCode } = event;
      switch (keyCode) {
        case KEYBOARD_CONST.enter:
        case KEYBOARD_CONST.space:
          displayModal.value = !displayModal.value;
          break;
        default:
          break;
      }
    }

    function onCloseModal() {
      displayModal.value = false;

      if (buttonRef.value) {
        buttonRef.value.focus();
      }
    }

    return {
      displayModal,
      inputRef,
      buttonRef,
      isHeaderMode,
      isScreenMdMin,
      initialSearch,
      searchPlaceholderTitle,
      handleKeydown,
      onCloseModal,
    };
  },
};
</script>
<style lang="scss">
.hero-banner-search-mobile {
  .btn-search {
    height: 47px;
    width: 47px;
  }
  .input-what {
    margin-right: 0px !important;
    min-width: inherit !important;
  }
}
</style>
